import { VStack } from '@chakra-ui/react';
import { useState } from 'react';

import { useOutcomesFFEnabled } from 'featureFlags/hooks/useOutcomesFFEnabled';
import { Flex, Show } from 'shared';

import { IPlanningDraftSprint } from 'features/planning';
import { PlanningSprintHeaderOutcomes } from 'features/planning/components/Board/Sprint/Header/Outcomes';

import { PlanningDraftSprintHeaderEditor } from './HeaderEditor';
import { PlanningDraftSprintHeaderViewer } from './HeaderViewer';

type TPlanningDraftSprintHeader = {
  sprint: IPlanningDraftSprint;
};

export const PlanningDraftSprintHeader = ({
  sprint,
}: TPlanningDraftSprintHeader) => {
  const [isEditing, setIsEditing] = useState(false);
  const isOutcomesFFEnabled = useOutcomesFFEnabled();

  return (
    <VStack w="full" gap={0}>
      <Flex
        data-testid="sprint-planning-board-header"
        height="100%"
        width="100%"
        justifyContent="space-between"
        alignItems="center"
      >
        {!isEditing ? (
          <PlanningDraftSprintHeaderViewer
            sprint={sprint}
            onEdit={() => setIsEditing(true)}
          />
        ) : (
          <PlanningDraftSprintHeaderEditor
            sprint={sprint}
            onDone={() => setIsEditing(false)}
          />
        )}
      </Flex>
      <Show when={isOutcomesFFEnabled}>
        <PlanningSprintHeaderOutcomes
          title={sprint.title}
          sprintOutcomes={sprint.sprintOutcomes}
          sprintId={sprint.sprintId}
        />
      </Show>
    </VStack>
  );
};
